export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path fill="currentcolor" fill-rule="evenodd" d="M6.328 2.016h13.567L16.587 5.4h1.626c1.547 0 2.333 1.86 1.256 2.97l-8.46 8.713 7.237.047c1.56.01 2.328 1.901 1.217 2.996L17.563 22H4.146l3.339-3.44-1.697-.01c-1.544-.01-2.32-1.87-1.24-2.974l8.476-8.675H5.766c-1.537 0-2.328-1.84-1.27-2.954l1.832-1.931Z" clip-rule="evenodd"/>
</svg>
`;
